import ability from "./ability";

export function setAbilities(access_map) {

  if (!access_map || !access_map.length) {
    return
  }
  const ability_arr = [{
    action: "read",
    subject: "home"
  }];

  for (const map of access_map) {


    if (map.create === 'Y') {
      ability_arr.push({
        action: "create",
        subject: map.module_name
      })
    }

    if (map.read === 'Y') {
      ability_arr.push({
        action: "read",
        subject: map.module_name
      })
    }

    if (map.update === 'Y') {
      ability_arr.push({
        action: "update",
        subject: map.module_name
      })
    }

    if (map.delete === 'Y') {
      ability_arr.push({
        action: "delete",
        subject: map.module_name
      })
    }
  }

  localStorage.setItem("abilities", JSON.stringify(ability_arr))
  ability.update(ability_arr);
}



// WEBPACK FOOTER //
// ./src/libs/acl/setAbilities.js